module.exports = __webpack_public_path__ + "static/media/alert.0a4d5c10.svg";